import React, { useEffect, useState } from "react";
import {
  Drawer,
  Button,
  Spin,
  Empty,
  Image,
  //   Space,
  Typography,
  //   Tag,
  message,
  //   Divider,
} from "antd";
import {
  //   DownloadOutlined,
  FileOutlined,
  AudioOutlined,
} from "@ant-design/icons";
import axios from "axios";
import PropTypes from "prop-types";
import { BASE_CRM_URL } from "../../../components/config/config";
// import { API_BASE_CRM_URL } from "../Config/Config";

const { Text } = Typography;

const FilesDrawer = ({ open, onClose, relId, relType }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  //   const [downloadingId, setDownloadingId] = useState(null);

  const fetchFiles = async () => {
    if (!relId || !relType) {
      setFiles([]);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}Files/GetFiles`, {
        params: {
          rel_id: relId,
          rel_type: relType,
        },
      });

      if (response.data?.Status) {
        setFiles(response.data.ResultData || []);
      } else {
        setFiles([]);
        message.error(response.data?.Message || "Failed to retrieve files.");
      }
    } catch (error) {
      console.error("GetFiles API error:", error);
      setFiles([]);
      message.error(
        error.response?.data?.Message || "Failed to load attachments.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchFiles();
    } else {
      setFiles([]);
    }
    // Fetch again whenever the drawer opens for a different record.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, relId, relType]);

  const isAudio = (file) =>
    file.filetype?.startsWith("audio/") ||
    /\.(mp3|wav|ogg|m4a|webm)$/i.test(file.file_name || "");

  const isImage = (file) =>
    file.filetype?.startsWith("image/") ||
    /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(file.file_name || "");

  const formatDate = (date) => {
    if (!date) return "—";

    const parsed = new Date(date);

    return Number.isNaN(parsed.getTime()) ? "—" : parsed.toLocaleString();
  };

  //   const downloadFile = async (file) => {
  //     if (!file.external_link) {
  //       message.error("Download URL is not available.");
  //       return;
  //     }

  //     setDownloadingId(file.id);

  //     try {
  //       // Download the file as a Blob.
  //       const response = await axios.get(file.external_link, {
  //         responseType: "blob",
  //       });

  //       const blobUrl = URL.createObjectURL(response.data);
  //       const anchor = document.createElement("a");

  //       anchor.href = blobUrl;
  //       anchor.download = file.file_name || "attachment";
  //       document.body.appendChild(anchor);
  //       anchor.click();
  //       anchor.remove();

  //       // Allow the browser time to start the download.
  //       setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  //     } catch (error) {
  //       console.error("Download error:", error);

  //       // Cross-origin storage may block Blob downloads through CORS.
  //       // Open the original URL as a fallback.
  //       window.open(file.external_link, "_blank", "noopener,noreferrer");

  //       message.warning(
  //         "Direct download was blocked. Opened the file link instead.",
  //       );
  //     } finally {
  //       setDownloadingId(null);
  //     }
  //   };

  const renderFilePreview = (file) => {
    if (isAudio(file)) {
      return (
        <div className="mt-3">
          <div className="d-flex align-items-center mb-2">
            <AudioOutlined
              style={{
                fontSize: 20,
                color: "#1B2850",
                marginRight: 8,
              }}
            />
            <Text strong>Voice Recording</Text>
          </div>

          <audio
            controls
            preload="metadata"
            src={file.external_link}
            style={{
              width: "100%",
              maxWidth: 450,
              display: "block",
            }}
          >
            Your browser does not support audio playback.
          </audio>
        </div>
      );
    }

    if (isImage(file)) {
      return (
        <div className="mt-3">
          <Image
            src={file.external_link}
            alt={file.file_name}
            width={120}
            height={100}
            style={{
              objectFit: "cover",
              borderRadius: 8,
            }}
            preview
          />
        </div>
      );
    }

    return (
      <div className="mt-3 text-muted">
        <FileOutlined className="me-2" />
        Preview is not available for this file type.
      </div>
    );
  };

  return (
    <Drawer
      title={
        <div>
          <div style={{ color: "#1B2850", fontWeight: 700 }}>
            {" "}
            <h4>Attachments</h4>{" "}
          </div>
        </div>
      }
      placement="right"
      width={650}
      open={open}
      onClose={onClose}
      closable={false}
      destroyOnHidden
      extra={
        <Button
          onClick={onClose}
          loading={loading}
          className="
        text-danger"
        >
          X
        </Button>
      }
    >
      <Spin spinning={loading} tip="Loading attachments...">
        {!loading && files.length === 0 ? (
          <Empty description="No attachments found" />
        ) : (
          <div>
            {files.map((file) => (
              <React.Fragment key={file.id}>
                <div className="p-3 rounded border mb-3">
                  <div className="row align-items-center g-3">
                    {/* Left side: File information - 4 columns */}
                    <div className="col-4">
                      <div className="d-flex align-items-start gap-2">
                        {isAudio(file) ? (
                          <AudioOutlined
                            style={{
                              fontSize: 22,
                              color: "#1B2850",
                              marginTop: 3,
                              flexShrink: 0,
                            }}
                          />
                        ) : (
                          <FileOutlined
                            style={{
                              fontSize: 22,
                              color: "#1B2850",
                              marginTop: 3,
                              flexShrink: 0,
                            }}
                          />
                        )}

                        <div style={{ minWidth: 0, overflowWrap: "anywhere" }}>
                          <h6>{file.file_name}</h6>

                          <div className="mt-2">
                            <p type="" style={{ fontSize: 12 }}>
                              Uploaded by: {file.uploaded_by || "Unknown"}
                            </p>
                          </div>

                          <div className="mt-1">
                            <p type="" style={{ fontSize: 12 }}>
                              {formatDate(file.dateadded)}
                            </p>
                          </div>

                          {/* <Button
                            className="mt-3"
                            type="primary"
                            icon={<DownloadOutlined />}
                            loading={downloadingId === file.id}
                            onClick={() => downloadFile(file)}
                            block
                          >
                            Download
                          </Button> */}
                        </div>
                      </div>
                    </div>

                    {/* Right side: File preview - 8 columns */}
                    <div className="col-8">
                      {/* <div
                        className="p-2 rounded"
                        style={{
                          background: "#f8f9fc",
                          minHeight: 100,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                        }}
                      >
                        {renderFilePreview(file)}
                      </div> */}
                      {renderFilePreview(file)}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </Spin>
    </Drawer>
  );
};

FilesDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  relId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  relType: PropTypes.string,
};

export default FilesDrawer;
